module.exports = __webpack_public_path__ + "img/time-filter.2dfa8e81.svg";